import { useRouter } from 'next/router';

export const useGetProductIdInQueryParams = () => {
  const router = useRouter();
  const productId = router?.query.catalog_product_id
    ? String(router?.query.catalog_product_id)
    : String(router?.query.id);
  return productId;
};
